import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { MyModal } from './../components/common/my-modal/my-modal.component';
import { LoggerService } from './logger.service';
import * as fromRoot from '../store/reducers';
import { AppUiActions } from '../store/actions';


declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Injectable()
export class FullscreenService {

    constructor(
        private loggerService: LoggerService,
        private myModal: MyModal,
        private store: Store<fromRoot.State>,
    ) {
    }

    tryFullScreen(): Promise<void> {
        return (document.body as any as Document).requestFullscreen();
    }

    tryExitFullScreen(): Promise<void> {
        return (document as any as Document).exitFullscreen();
    }

    showFullScreenErrorDlg(err: any) {
        this.myModal.showRegularDlg("Error", "Error attempting to enable full-screen mode: ${err.message} (${err.name}) \nTesting cannot proceed without fullscreen enabled")
    }
}

export interface Document extends HTMLDocument {
    requestFullscreen(): Promise<void>;
    exitFullscreen(): Promise<void>;
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/fullscreen.service.ts